import React, { useState, useEffect } from 'react';
import { Paper, IconButton, Typography, TextField } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';

const useStyles = makeStyles((_theme) => ({
  filterName: {
    color: "var(--Neutral-Colors-Text-Black, #333)",
    fontFamily: 'Poppins, sans-serif',
    fontSize: "12px",
    fontWeight: "600",
    lineHeight: "normal",
    flex: 1
  },
  icons: {
    margin: "0px 15px",
    cursor: 'pointer'
  },
}));

function EditSavedFilters({ handleEditSavedFilterClose, filterName, _handleViewSavedFilter, handleSavedFilterEdit, _ApplyFilterActions, handleFiltersDelete, _applyFilter, savedFilterList, _networkFilterChange }) {
  const classes = useStyles();
  const [filteredSavedFilters, setFilteredSavedFilters] = useState(savedFilterList);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    if (filterName.length === 0) {return;}
    if (filterName[0].trim() !== '') {
      const filteredList = savedFilterList && savedFilterList.filter(item => item.FilterName[0].toLowerCase().includes(filterName[0].toLowerCase()));
      setFilteredSavedFilters(filteredList);
    } else {
      setFilteredSavedFilters(savedFilterList);
    }
  }, [filterName, savedFilterList]);
  const handleEdit = (id, item) => {
    handleSavedFilterEdit(id, item);
  };

  const handleDelete = (index) => {
    handleFiltersDelete(index);
    const deleteSavedFilter = savedFilterList.filter(val => val.id !== index);
    setFilteredSavedFilters(deleteSavedFilter);
  };

  const handleSearchValue = (event) => {
    setSearchValue(event.target.value);
  };

  useEffect(()=>{
      const filteredData = savedFilterList?.filter((item) => 
          item?.FilterName?.toLowerCase()?.includes(searchValue?.toLowerCase()) 
      );
      setFilteredSavedFilters([...filteredData]);
  }, [searchValue]);

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Typography sx={{ fontSize: '14px', color: '#222', padding: "0px 15px" }}>Saved Filters</Typography>
        <CloseIcon className={classes.icons} onClick={handleEditSavedFilterClose} />
      </div>
      <div>
          <TextField
          id="outlined-basic" 
          size="small"
          label="" 
          value={searchValue}
          variant="outlined" 
          onChange={handleSearchValue}
          placeholder="Search..."
          sx={{
              //margin: "5px 15px 5px 15px",
              background: "#ffffff",
              marginTop: "5px",
              padding: "0px 10px",
              width: "100%",
              "& .MuiInputBase-root": {
                  height: "30px", // Adjust height here
              },
              "& .MuiInputBase-input": {
              padding: "10px", // Adjust padding to reduce height further
              fontSize: "14px", // Optionally reduce font size
              }

          }}/>
      </div>

      {
        filteredSavedFilters?.length > 0 &&
        filteredSavedFilters
          .sort((a, b) => {
            const userID = JSON.parse(localStorage.getItem("userDetails"))?.UserID?.toLowerCase();
            const isAMatch = a?.UserID?.toLowerCase() === userID;
            const isBMatch = b?.UserID?.toLowerCase() === userID;

            // Sort so that matching UserID values come first
            if (isAMatch && !isBMatch) { return -1; }  // a comes before b
            if (!isAMatch && isBMatch) { return 1; }   // b comes before a
            return 0;  // No change in order if both are the same
          })
          .map((item, index) => (
            <Paper
              key={index}
              elevation={0}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '10px',
                margin: '20px 10px',
                height: '40px',
                borderRadius: '6px'
              }}
            >
              <span className={classes.filterName}>{item.FilterName}</span>
              {item?.UserID?.toLowerCase() === JSON.parse(localStorage.getItem("userDetails"))?.UserID?.toLowerCase() && (
                <>
                  <IconButton aria-label="edit">
                    <BorderColorOutlinedIcon
                      onClick={() => handleEdit(item.id, item)}
                      style={{ color: "#0067A1", fontSize: "20px" }}
                    />
                  </IconButton>
                  <IconButton
                    aria-label="delete"
                    onClick={() => handleDelete(item.id)}
                  >
                    <DeleteOutlineIcon style={{ color: "#0067A1", fontSize: "20px" }} />
                  </IconButton>
                </>
              )}
            </Paper>
          ))
      }
    </div>
  );
}

const mapDispatchToProps = dispatch => ({
  ApplyFilterActions: newValue => dispatch({ type: 'APPLY_FILTER', payload: newValue }),
  networkFilterChange: newValue => dispatch({ type: 'FILTER_NETWORK', payload: newValue }),
  DCFilterChange: newValue => dispatch({ type: 'FILTER_DC', payload: newValue }),
  productsFilterChange: newValue => dispatch({ type: 'FILTER_PRODUCTS', payload: newValue }),
  pl3FilterChange: newValue => dispatch({ type: 'FILTER_PL3', payload: newValue }),
  cl6FilterChange: (newValue) => dispatch({ type: "FILTER_CL6", payload: newValue }),
  divisionFilterChange: newValue => dispatch({ type: 'FILTER_DIVISION', payload: newValue }),
});

export default connect(null, mapDispatchToProps)(EditSavedFilters);
